import { pence } from '@cf/shared';
/**
 * Basis-point arithmetic on integer pence. Every product is truncated toward
 * zero so results are deterministic and never overstate a liability by a
 * fractional penny. All inputs and outputs stay integer pence.
 */
export function mulBps(amount, bps) {
    if (!Number.isInteger(bps) || bps < 0) {
        throw new RangeError(`Rate must be a non-negative integer number of basis points: ${bps}`);
    }
    return pence(Math.trunc((amount * bps) / 10_000));
}
/** max(0, a - b) on pence — the "excess over a threshold" idiom. */
export function excessOver(amount, threshold) {
    return pence(Math.max(0, amount - threshold));
}
/** Clamp to the closed range [0, cap]. */
export function clampTo(amount, cap) {
    return pence(Math.min(Math.max(0, amount), Math.max(0, cap)));
}
export function minPence(a, b) {
    return a < b ? a : b;
}
export function maxPence(a, b) {
    return a > b ? a : b;
}
//# sourceMappingURL=bps.js.map